import React, { useEffect, useState, useRef } from "react";
import "./Converter.css";
import Nav3 from '../../../Navs/SideView/Nav3';
import { Helmet } from "react-helmet";
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../../../../firebase';
import { doc, getDoc, updateDoc, increment } from 'firebase/firestore';
import styled from "styled-components";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import Modal from "./Modal";
import ViewCounter from '../../../ViewCounter';
import { FaShare, FaHeart, FaRegHeart, FaVolumeUp, FaHistory } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const Container = styled.div`
  background-color: #030617;
  background-image: linear-gradient(to bottom, #030617, #0a1128);
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(to bottom, rgba(75, 192, 192, 0.05), transparent);
    z-index: 0;
  }
`;

const CardContainer = styled(motion.div)`
  width: 100%;
  max-width: 800px;
  margin: 20px auto;
  padding: 30px;
  background: linear-gradient(145deg, #1c2237 0%, #151a2b 100%);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1;
  
  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(45deg, rgba(75, 192, 192, 0.1), transparent, rgba(75, 192, 192, 0.1));
    border-radius: 22px;
    z-index: -1;
  }
`;

const StationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  margin-bottom: 30px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 16px;
  backdrop-filter: blur(10px);

  @media (max-width: 600px) {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }
`;

const StationImage = styled.div`
  position: relative;
  width: 140px;
  height: 140px;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 50%;
    background: linear-gradient(45deg, rgba(75, 192, 192, 0.2), rgba(75, 192, 192, 0));
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  @media (max-width: 600px) {
    width: 120px;
    height: 120px;
  }
`;

const StationLogo = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid rgba(75, 192, 192, 0.3);
`;

const StationDetails = styled.div`
  flex: 1;
`;

const StationName = styled.h1`
  font-size: 2rem;
  color: #fff;
  margin-bottom: 10px;
  font-weight: 600;
  
  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

const LiveBadge = styled.div`
  display: inline-flex;
  align-items: center;
  background: rgba(75, 192, 192, 0.1);
  color: rgb(75, 192, 192);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  margin-bottom: 15px;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    background: rgb(75, 192, 192);
    border-radius: 50%;
    margin-right: 8px;
    animation: blink 1.5s infinite;
  }

  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
  }
`;

const PlayerContainer = styled.div`
  position: relative;
  margin-bottom: 20px;
  
  .rhap_container {
    background: rgba(255, 255, 255, 0.03);
    box-shadow: none;
    padding: 20px;
    border-radius: 16px;
    backdrop-filter: blur(10px);
  }

  .rhap_main-controls-button {
    color: rgb(75, 192, 192);
    transition: transform 0.2s, color 0.2s;

    &:hover {
      transform: scale(1.1);
      color: rgb(95, 212, 212);
    }
  }

  .rhap_progress-filled {
    background-color: rgb(75, 192, 192);
  }

  .rhap_progress-indicator {
    background: rgb(75, 192, 192);
    box-shadow: 0 0 5px rgba(75, 192, 192, 0.5);
  }

  .rhap_time {
    color: rgba(255, 255, 255, 0.7);
  }

  .rhap_volume-button {
    color: rgba(255, 255, 255, 0.7);
  }

  .rhap_volume-bar {
    background: rgba(255, 255, 255, 0.1);
  }

  .rhap_volume-indicator {
    background: rgb(75, 192, 192);
    box-shadow: 0 0 5px rgba(75, 192, 192, 0.5);
  }
  
  .rhap_play-pause-button {
    font-size: 40px;
    width: 40px;
    height: 40px;
  }
`;

const AdContainer = styled.div`
  width: 100%;
  max-width: 728px;
  margin: 20px 0;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

// Add new styled components for the enhanced UI
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  color: white;
`;

const LoadingSpinner = styled.div`
  width: 60px;
  height: 60px;
  border: 5px solid rgba(75, 192, 192, 0.1);
  border-top-color: rgb(75, 192, 192);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

const LoadingText = styled.div`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
`;

const VolumeVisualizer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 40px;
  width: 100%;
  margin: 15px 0;
  gap: 3px;
`;

const VisualizerBar = styled(motion.div)`
  background-color: rgb(75, 192, 192);
  width: 4px;
  border-radius: 2px;
  opacity: 0.8;
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  padding: 10px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  padding: 10px;
  border-radius: 8px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.05);
    color: rgb(75, 192, 192);
  }
  
  svg {
    margin-bottom: 5px;
    font-size: 20px;
  }
`;

const StationDescription = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 1.6;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const ShareModal = styled(motion.div)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #1c2237;
  padding: 20px;
  border-radius: 10px;
  z-index: 1000;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
`;

const ShareModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  backdrop-filter: blur(3px);
`;

const ShareButton = styled.button`
  background: rgba(75, 192, 192, 0.1);
  color: rgb(75, 192, 192);
  border: 1px solid rgba(75, 192, 192, 0.3);
  border-radius: 8px;
  padding: 10px 15px;
  margin: 10px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(75, 192, 192, 0.2);
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
`;

const RecentlyPlayed = styled.div`
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
`;

const RecentlyPlayedTitle = styled.h3`
  color: white;
  font-size: 18px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  
  svg {
    margin-right: 10px;
  }
`;

const RecentlyPlayedList = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 15px;
  padding-bottom: 10px;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(75, 192, 192, 0.3);
    border-radius: 4px;
  }
`;

const RecentlyPlayedItem = styled.div`
  flex: 0 0 auto;
  width: 80px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid rgba(75, 192, 192, 0.3);
  }
  
  p {
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
    margin-top: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

function OnlineRadioPlayer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [radio, setRadio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [recentlyPlayed, setRecentlyPlayed] = useState([]);
  const playerRef = useRef(null);
  
  // Generate random heights for volume visualizer
  const generateBars = () => {
    return Array.from({ length: 20 }, () => ({
      height: isPlaying ? Math.random() * 30 + 5 : 3,
      duration: Math.random() * 0.5 + 0.2
    }));
  };
  
  const [bars, setBars] = useState(generateBars());
  
  // Update visualizer bars when playing
  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        setBars(generateBars());
      }, 100);
    }
    
    return () => clearInterval(interval);
  }, [isPlaying]);

  // Fetch radio station data
  useEffect(() => {
    const fetchRadio = async () => {
      setLoading(true);
      try {
        const radioRef = doc(db, "stations", id);
        const docSnap = await getDoc(radioRef);
        
        if (docSnap.exists()) {
          const radioData = docSnap.data();
          setRadio(radioData);
          
          // Update play count
          try {
            await updateDoc(radioRef, {
              playCount: increment(1)
            });
          } catch (updateError) {
            console.error("Error updating play count:", updateError);
          }
          
          // Add to recently played
          const recentlyPlayedStations = JSON.parse(localStorage.getItem('recentlyPlayedRadios') || '[]');
          
          // Check if this station is already in recently played
          const existingIndex = recentlyPlayedStations.findIndex(station => station.id === id);
          if (existingIndex !== -1) {
            // Remove it so we can add it to the front
            recentlyPlayedStations.splice(existingIndex, 1);
          }
          
          // Add current station to the front
          recentlyPlayedStations.unshift({
            id,
            title: radioData.title,
            image: radioData.image
          });
          
          // Keep only the last 5 stations
          const updatedRecent = recentlyPlayedStations.slice(0, 5);
          localStorage.setItem('recentlyPlayedRadios', JSON.stringify(updatedRecent));
          setRecentlyPlayed(updatedRecent);
          
          // Check if this station is a favorite
          const favorites = JSON.parse(localStorage.getItem('favoriteRadios') || '[]');
          setIsFavorite(favorites.some(fav => fav.id === id));
          
        } else {
          setError("Radio station not found");
          console.log("No such document!");
        }
      } catch (error) {
        setError("Error loading radio station");
        console.error("Error fetching radio:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchRadio();
    
    // Load recently played stations
    const recentlyPlayedStations = JSON.parse(localStorage.getItem('recentlyPlayedRadios') || '[]');
    setRecentlyPlayed(recentlyPlayedStations);
    
  }, [id]);

  // Toggle favorite status
  const toggleFavorite = () => {
    const favorites = JSON.parse(localStorage.getItem('favoriteRadios') || '[]');
    
    if (isFavorite) {
      // Remove from favorites
      const updatedFavorites = favorites.filter(fav => fav.id !== id);
      localStorage.setItem('favoriteRadios', JSON.stringify(updatedFavorites));
    } else {
      // Add to favorites
      favorites.push({
        id,
        title: radio.title,
        image: radio.image
      });
      localStorage.setItem('favoriteRadios', JSON.stringify(favorites));
    }
    
    setIsFavorite(!isFavorite);
  };
  
  // Share station
  const shareStation = async (platform) => {
    const url = window.location.href;
    const title = `Listen to ${radio?.title} Live Stream on Konzo Vibez`;
    
    switch (platform) {
      case 'copy':
        try {
          await navigator.clipboard.writeText(url);
          alert('Link copied to clipboard!');
        } catch (err) {
          console.error('Failed to copy: ', err);
        }
        break;
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(title + ' ' + url)}`);
        break;
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`);
        break;
      case 'twitter':
        window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`);
        break;
      default:
        break;
    }
    
    setShowShareModal(false);
  };
  
  // Navigate to another station
  const navigateToStation = (stationId) => {
    navigate(`/radio/${stationId}`);
  };

  return (
    <>
      <Modal />
      <Nav3 />
      
      <AnimatePresence>
        {showShareModal && (
          <>
            <ShareModalOverlay 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setShowShareModal(false)}
            />
            <ShareModal
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: 'spring', damping: 20 }}
            >
              <h3 style={{ color: 'white', marginBottom: '20px' }}>Share this station</h3>
              <CloseButton onClick={() => setShowShareModal(false)}>×</CloseButton>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                <ShareButton onClick={() => shareStation('copy')}>Copy Link</ShareButton>
                <ShareButton onClick={() => shareStation('whatsapp')}>WhatsApp</ShareButton>
                <ShareButton onClick={() => shareStation('facebook')}>Facebook</ShareButton>
                <ShareButton onClick={() => shareStation('twitter')}>Twitter</ShareButton>
              </div>
            </ShareModal>
          </>
        )}
      </AnimatePresence>
      
      <Container>
        {loading ? (
          <LoadingContainer>
            <LoadingSpinner />
            <LoadingText>Loading radio station...</LoadingText>
          </LoadingContainer>
        ) : error ? (
          <LoadingContainer>
            <h2 style={{ color: 'white', marginBottom: '20px' }}>Error</h2>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)' }}>{error}</p>
            <button 
              style={{ 
                marginTop: '20px', 
                background: 'rgba(75, 192, 192, 0.1)', 
                color: 'rgb(75, 192, 192)',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
              onClick={() => navigate('/radios')}
            >
              Back to Radio Stations
            </button>
          </LoadingContainer>
        ) : radio && (
          <>
            <Helmet>
              <title>{`${radio.title || ''} Live Stream`}</title>
              <meta name="description" content={`Listen to ${radio.title || 'Radio'} live stream - Best of Kasese entertainment`} />
              <meta property="og:title" content={`${radio.title || 'Radio'} Live Stream`} />
              <meta property="og:image" content={radio.image || ''} />
              <link rel="icon" href={radio.image || ''} />
            </Helmet>
            
            <CardContainer
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <StationInfo>
                <StationImage>
                  <StationLogo src={radio.image} alt={radio.title} />
                </StationImage>
                <StationDetails>
                  <StationName>{radio.title}</StationName>
                  <LiveBadge>LIVE</LiveBadge>
                  {radio.description && (
                    <StationDescription>{radio.description}</StationDescription>
                  )}
                </StationDetails>
              </StationInfo>

              <VolumeVisualizer>
                {bars.map((bar, index) => (
                  <VisualizerBar
                    key={index}
                    animate={{ height: bar.height }}
                    transition={{ duration: bar.duration, repeat: Infinity, repeatType: 'reverse' }}
                  />
                ))}
              </VolumeVisualizer>

              <PlayerContainer>
                <AudioPlayer
                  ref={playerRef}
                  src={radio.url}
                  autoPlay
                  showJumpControls={false}
                  customControlsSection={['MAIN_CONTROLS', 'VOLUME_CONTROLS']}
                  layout="horizontal"
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                  onError={(e) => console.error("Audio player error:", e)}
                />
              </PlayerContainer>
              
              <ActionButtons>
                <ActionButton onClick={toggleFavorite}>
                  {isFavorite ? <FaHeart color="rgb(75, 192, 192)" /> : <FaRegHeart />}
                  <span>{isFavorite ? 'Favorited' : 'Favorite'}</span>
                </ActionButton>
                <ActionButton onClick={() => setShowShareModal(true)}>
                  <FaShare />
                  <span>Share</span>
                </ActionButton>
                <ActionButton onClick={() => navigate('/radios')}>
                  <FaVolumeUp />
                  <span>All Stations</span>
                </ActionButton>
              </ActionButtons>
              
              {recentlyPlayed.length > 1 && (
                <RecentlyPlayed>
                  <RecentlyPlayedTitle>
                    <FaHistory /> Recently Played
                  </RecentlyPlayedTitle>
                  <RecentlyPlayedList>
                    {recentlyPlayed
                      .filter(station => station.id !== id) // Don't show current station
                      .map((station, index) => (
                        <RecentlyPlayedItem 
                          key={index}
                          onClick={() => navigateToStation(station.id)}
                        >
                          <img src={station.image} alt={station.title} />
                          <p>{station.title}</p>
                        </RecentlyPlayedItem>
                      ))}
                  </RecentlyPlayedList>
                </RecentlyPlayed>
              )}
            </CardContainer>

            <AdContainer>
              <ins className="adsbygoogle"
                style={{ display: "block" }}
                data-ad-client="ca-pub-2968429081843062"
                data-ad-slot="8703718386"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
            </AdContainer>

            <AdContainer>
              <ins className="adsbygoogle"
                style={{ display: "block" }}
                data-ad-client="ca-pub-2968429081843062"
                data-ad-slot="8456694735"
                data-ad-format="auto"
                data-full-width-responsive="true"></ins>
            </AdContainer>
            <ViewCounter path={`/radio/${id}`} />
          </>
        )}
      </Container>
    </>
  );
}

export default OnlineRadioPlayer;
